"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ResourceLoader = _interopRequireDefault(require("./ResourceLoader"));

var ResourceListLoader = function (props) {
  return _react.default.createElement(_ResourceLoader.default, (0, _extends2.default)({}, props, {
    list: true
  }));
};

process.env.NODE_ENV !== "production" ? ResourceListLoader.propTypes = {
  children: _propTypes.default.func.isRequired,
  entityType: _propTypes.default.string,
  autoCaseKeys: _propTypes.default.bool,
  autoLoad: _propTypes.default.bool,
  postRequest: _propTypes.default.bool,
  renderError: _propTypes.default.func,
  renderInitial: _propTypes.default.func,
  renderLoading: _propTypes.default.func,
  renderSuccess: _propTypes.default.func,
  requestParams: _propTypes.default.object,
  resource: _propTypes.default.string.isRequired
} : void 0;
var _default = ResourceListLoader;
exports.default = _default;